<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  class="cabinet-section-2d cabinet-section-interior"
  preserveAspectRatio="xMinYMin"
  [attr.viewBox]="canvasViewBoxString"
>
  <g class="ruler-view" *ngIf="showRulers">
    <g *ngFor="let ruler of rulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>

  <g
    *ngFor="let item of backingItems"
    [attr.transform]="getItemTransformString(item)"
  >
    <image
      href=""
      width="0"
      height="0"
      preserveAspectRatio="none"
      [attr.href]="backingMaterialUrl"
      [attr.width]="item.Width"
      [attr.height]="item.Height"
    />

    <g class="item-ruler-overlay" *ngIf="showRulers">
      <rect
        class="item-ruler-background"
        width="0"
        style="fill: rgba(255, 255, 255, 0.5)"
        height="0"
        [attr.width]="itemRulerBackgroundWidth"
        [attr.height]="itemRulerBackgroundHeight"
        [attr.x]="(item.Width - itemRulerBackgroundWidth) / 2"
        [attr.y]="(item.Height - itemRulerBackgroundHeight) / 2"
      ></rect>

      <text
        class="item-ruler-text"
        style="font-size: 40px"
        [attr.x]="item.Width / 2"
        [attr.y]="item.Height / 2 + 13"
        text-anchor="middle"
      >
        {{ item.PositionNumber }}
      </text>
    </g>
  </g>

  <g
    *ngFor="let gable of gables"
    [attr.transform]="getItemTransformString(gable)"
  >
    <rect
      width="0"
      height="0"
      class="item-no-img-fallback"
      [attr.width]="gable.Width"
      [attr.height]="gable.Height"
    />
  </g>

  <g class="corpus">
    <g class="corpus-items">
      <g
        *ngFor="let item of corpusItems"
        class="corpus-item"
        [attr.transform]="getItemTransformString(item)"
      >
        <image
          width="0"
          height="0"
          class="item-material-only-fallback"
          href=""
          [attr.href]="item.Material.ImagePath"
          *ngIf="(!item.getModel2DPath()) &amp;&amp; item.Material &amp;&amp; item.Material.ImagePath"
          preserveAspectRatio="none"
          [attr.height]="item.Height"
          [attr.width]="item.Width"
        />

        <rect
          width="0"
          height="0"
          class="item-no-img-fallback"
          *ngIf="item.getModel2DPath()"
          style="stroke: gray; stroke-width: 2px; fill: rgba(0, 0, 0, 0.01)"
          [attr.height]="item.Height"
          [attr.width]="item.Width"
        ></rect>
      </g>
    </g>
    <g class="corpus-joints">
      <g
        class="corpus-joint"
        *ngFor="let joint of corpusJoints"
        attr.transform="translate( {{ joint.X }} {{
          cabinetSection.Height - joint.Y
        }} )"
      >
        <line
          x1="0"
          x2="0"
          y1="0"
          y2="0"
          [attr.y2]="-joint.height"
          style="stroke: black; stroke-width: 10px"
        ></line>
      </g>
    </g>
  </g>

  <g
    *ngFor="let area of backingAreas"
    class="backing-area"
    [class]="{ enabled: area.enabled }"
    [attr.transform]="getTransformString(area.position, area.size.Y)"
    (click)="onBackingAreaClick(area)"
  >
    <rect
      width="0"
      height="0"
      style="opacity: 0"
      class="rect-area"
      [attr.width]="area.size.X"
      [attr.height]="area.size.Y"
    ></rect>
  </g>

  <rect
    class="cabinet-section-border"
    x="0"
    y="0"
    width="0"
    height="0"
    style="fill: none; stroke: black; stroke-width: 3px"
    [attr.width]="cabinetSection.Width"
    [attr.height]="cabinetSection.Height"
  ></rect>
</svg>
